<template>
  <div class="chat-room-header" :class="{mobile:isMobile}">
    <div class="hide">{{updateroom}}</div>
    <div class="icon" v-if="getChatroom">
        <img :src="`${$store.state.serverPath}${getChatroom.icon}`" width="45" height="45">
    </div>
    <div class="roomInfo" v-if="getChatroom">
      <div class="title">
        {{ getChatroom.title }}
      </div>
      <div class="infoDetail">
        <display-time :time="getChatroom.created_at"/>
        <span class="bar">|</span>
        참여인원 : <em>{{joincount}}명</em><span class="bar">|</span>
        <!-- 현재순위 : <em>3위</em><span class="bar">|</span>
        누적참여자 : 6,036명<span class="bar">|</span>
        누적포인트 : -1,676,700<span class="bar">|</span>
        누적추천수 : 10,272        -->
      </div>
    </div>
    <div class="toolBox"></div>
  </div>
  <div v-if="getChatroom && isMobile" class="subtitle">
    {{ getChatroom.subtitle }}
  </div>
</template>
<script>
import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import io from "socket.io-client";
export default {
  props: {
    room_id: {      
      required: true,
      default: null
    },
    isMobile:{
      default:false,
    },
    joincount:{
      default:0
    }
  },
  components:{
        DisplayTime
  },
  data() {
    return {
      chatroom: "",
      isLoading: false,  
      socket: io(this.$store.state.serverDomain + ":3000"),         
    };
  },
  computed:{
    getChatroom(){
      if(this.$store.state.chat.roomList)
      {
        //alert('룸리스트 있음');
        // this.chatroom =this.$store.getters["chat/getChatroomList"].find((room) => room.id === parseInt(this.room_id));
        // this.$emit("chatroom-info", this.chatroom);        
        return this.$store.getters["chat/getChatroomList"].find((room) => room.id === parseInt(this.room_id));
      }else{
        return this.chatroom;
      }
    },   
    updateroom(){
        if(this.$store.state.chat.updateroom)
        {
            //alert('방 업데이트');
            if(this.$store.state.chat.updateroom === this.getChatroom.id)
            {
                this.getRoomInfo();
                this.initroomstate();
            }           
            return true
        }else{
            return false
        }
    }
  },
//   watch:{
//     getChatroom(newVal, oldVal)
//     {
//         console.log('New',newVal);
//         console.log('Old',oldVal)
//         this.getRoomInfo();
//     }
//   },
  created() {
    // if(this.$store.state.chat.roomList)
    // {
    //   this.chatroom =this.$store.getters["chat/getChatroomList"].find((room) => room.id === parseInt(this.room_id));
    //   this.$emit("chatroom-info", this.chatroom);
    // }else{
      this.getRoomInfo();
    //}


  },
  methods: {
    initroomstate(){
        this.$store.state.chat.updateroom = '';
    },
    test() {
      console.log("테스트", this.$store.state.chat.roomList);
    },
    async getRoomInfo() {
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch("chat/getRoomInfo", {
            roomId: this.room_id,
        });
        //강퇴 유저 체크
        if(response.roomInfo.ban.length > 0)
        {            
            if(response.roomInfo.ban.find((ban)=>ban.user_id === this.$store.getters.currentUser.id))
            {
              alert('강퇴처리 되었습니다.');
              if(this.isMobile)
              {              
                    //상태 변경 알림
                let params = {
                    room_id: this.room_id,
                    description: this.$store.getters.currentUser.nic + ' 강퇴된 유저 진입시도',                    
                    user_id: this.$store.getters.currentUser.id,               
                }
                this.socket.emit("ForceOutUser", params, function (callback) {
                  console.log(callback);
                });
                this.$router.push({name:'m_ChatLobby'});
              }else{
                window.close();
              }
              
            }
        }

        this.$emit("sub-title", response.roomInfo.subtitle);
        console.log("방정보" + response);
        //console.log("방정보" + JSON.stringify(response.roomInfo));
        this.chatroom = response.roomInfo;
        this.$emit("chatroom-info", this.chatroom);
      } catch (error) {
        console.log("에러", error.response);
        //에러면 이전페이지로
        alert('존재 하지 않는 채팅방입니다.');
        if(this.isMobile)
        {
          this.$router.push({name:'m_ChatLobby'});
        }else{
          this.$router.push({name:'chat_Lobby'});
        }
        
      }
      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile{
  background-color: #150f63 !important; 
}
.subtitle{
  text-align: center;
  padding:5px;
}
.chat-room-header {
  display: flex;
  background-color: #39302d;
  height:45px;
  .hide{display:none}
  .icon {
    background-color: #000;
    width: 45px;
    height: 45px;
  }
  .roomInfo {
    font-size: 12px;
    padding: 5px 0px 0px 8px;
    .title {
      font-weight: 700;
      color: #fff;
      line-height: 15px;
      margin-bottom: 5px;
    }
    .infoDetail {
      color: #929292;
      line-height: 15px;
      display:flex;
      em {
        color: #ffde00;
        font-weight: 700;
        font-style: normal;
      }
      .bar {
        margin: 2px 10px 0;
        width: 1px;
        height: 11px;
        color: #4d4542;
      }
    }
  }
}
</style>
